import React,{useState} from 'react'
import Header from '../header/Header'
import '../statusCheck/StatusCheckView.css';
import { useSelector } from 'react-redux';
import red_line from '../../img/red_line.png';
import circle from '../../img/circle.svg';
import circleOk from '../../img/circleOk.svg';
import moment from 'moment';



export const StatusCheckView = () => {
    // const searchComplaint= useSelector((state) => state.searchComplaint.searchingComplaint);
    // const emails= useSelector((state) => state.searchComplaint.searchingComplaint.emails);
    // const products= useSelector((state) => state.searchComplaint.searchingComplaint.product);
    const searchComplaint = useSelector((state) => state.searchComplaint.searchingComplaint.complaintPosition);
    const complaintHeader = useSelector((state) => state.searchComplaint.searchingComplaint.complaintHeader);
    const complaintPositions = useSelector((state) => state.searchComplaint.searchingComplaint.complaintPosition);
    const customer = useSelector((state) => state.searchComplaint.searchingComplaint.customer);
    const emails = useSelector((state) => state.searchComplaint.searchingComplaint.customer.email);
    const products = useSelector((state) => state.searchComplaint.searchingComplaint.product);
    const [currentStatus, setCurrentStatus] = useState('');


    const handleStatusChange = (status) => {
        setCurrentStatus(status);
      };
    //   const status = [
    //     { status: 'Wysłane zgłoszenie', activeIcon: circleOk, inactiveIcon: circle },
    //     { status: 'W realizacji', activeIcon: circleOk, inactiveIcon: circle },
    //     { status: 'Produkt naprawiony', activeIcon: circleOk, inactiveIcon: circle },
    //     { status: 'Paczka w nadaniu', activeIcon: circleOk, inactiveIcon: circle }
    //   ];
      
      const statuses = useSelector((state) => state.searchComplaint.searchingComplaint.complaintPosition.positionStatuses);
      
      const statusList = statuses.map((item, index) => {
        const formattedDate = index < statuses.length ? moment(new Date(statuses[index].statusDate)).format('DD.MM.YYYY') : '';
        return {
          status: `${item.name} - ${formattedDate}`,
          activeIcon: circleOk,
          inactiveIcon: circle,
          isActive: index < statuses.length // Ustawia isActive na true dla statusów z datą, false dla pozostałych statusów
        };
      });
return (
    <div className='preview-complaint-page-container'>
        <Header/>
        <div className='preview-complaint-title-container'>
            <img style={{ marginLeft: "0px" }} src={red_line} className='red-line'/>
            <h3 className='preview-complaint-title-text'>Podgląd zgłoszenia</h3>
        </div>
        <div className='preview-complaint-information-container'>
            <div className='preview-status-container'>
                <h4 className='preview-status-title-text'>Status</h4>
                <div className='preview-statuses-list-container'>              
                        {statusList.map((item, index) => (
                            <div
                            key={index}
                            className={`status-item ${item.isActive ? 'active' : ''}`}
                            onClick={() => handleStatusChange(item.status)}
                            >
                            <img src={item.isActive ? item.activeIcon : item.inactiveIcon} alt={item.status} />
                            <span>{item.status}</span>
                            </div>
                        ))}

                </div>
            </div>
            <div className='preview-information-container'>
                <h4 className='preview-information-title-text'>Informacje podstawowe</h4>
                <div className='preview-complaint-type-container'>
                    <h6 className='preview-complaint-type-container-title'>Rodzaj zgłoszenia</h6>
                    <p className='preview-complaint-type-text'>{complaintHeader.complaintType.displayName}</p>
                </div>
                <div className='preview-complaint-date-container'>
                    <h6 className='preview-complaint-date-container-title'>Data utworzenia</h6>
                    <p className='preview-complaint-date-text'>{complaintHeader.createDate}</p>
                </div>
                <div className='preview-client-data-container'>
                    <h4 className='preview-client-data-title-text'>Dane klienta</h4>
                    <div className='preview-client-name-container'>
                        <h6 className='preview-client-name-container-title'>Imię i Nazwisko</h6>
                        <p className='preview-client-name-text'>{customer.name}</p>
                    </div>
                    <div className='preview-email-container'>
                        <h6 className='preview-email-container-title'>E-mail</h6>
                        <p className='preview-email-text'>{customer.email}</p>
                    </div>
                    <div className='preview-phone-container'>
                        <h6 className='preview-phone-container-title'>Telefon</h6>
                        <p className='preview-phone-text'>{customer.phone}</p>
                    </div>
                    <div className='preview-address-container'>
                        <h6 className='preview-address-container-title'>Adres</h6>
                        <p className='preview-address-text'>Ul.{customer.street}<br/>{customer.postalCode}<br/>{customer.city}</p>
                    </div>
                    <div className='complaint-details-container'>
                        <h4 className='complaint-details-container-title'>Produkty zgłoszone dla reklamacji</h4>
                        <div className='products-for-complaint-container'>
                            <h6 className='products-for-complaint-title'>{complaintPositions.product.name}</h6>
                            <hr/>
                            <ul className='products-for-complaint-details'>
                                <li className='products-for-complaint-details-row'>
                                    <p className='products-for-complaint-details-title'><b>Indeks</b></p>
                                    <p className='products-for-complaint-details-text'>{complaintPositions.product.code || '-'}</p>
                                   
                                </li>
                                <hr/>
                                <li className='products-for-complaint-details-row'>
                                    <p className='products-for-complaint-details-title'><b>Data wykrycia wady </b></p>
                                    <p className='products-for-complaint-details-text'>{complaintPositions.faultDate.format('YYYY-MM-DD') || 'Brak'}</p>
                                   
                                </li>
                                <hr/>
                                <li className='products-for-complaint-details-row'>
                                    <p className='products-for-complaint-details-title'><b>Okoliczności wykrycia wady</b></p>
                                    <p className='products-for-complaint-details-text'>{complaintPositions.faultDiscoveryCircumstances || 'Brak'}</p>
                                   
                                </li>
                                <hr/>
                                <li className='products-for-complaint-details-row'>
                                    <p className='products-for-complaint-details-title'><b>Opis przesyłki</b></p>
                                    <p className='products-for-complaint-details-text'>{complaintPositions.shipmentDescription || '-'}</p>
                                   
                                </li>
                                <hr/>
                                <li className='products-for-complaint-details-row'>
                                    <p className='products-for-complaint-details-title'><b>Numer dokumentu sprzedaży</b></p>
                                    <p className='products-for-complaint-details-text'>{complaintPositions.salesDocumentNumber || 'Brak'}</p>
                                   
                                </li>
                                <hr/>
                                <li className='products-for-complaint-details-row'>
                                    <p className='products-for-complaint-details-title'><b>Uwagi</b></p>
                                    <p className='products-for-complaint-details-text'>{complaintPositions.notes || '-'}</p>
                                   
                                </li>
                               
                                
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  )
}


